module.exports = __webpack_public_path__ + "static/media/1 Minutes Ramesh Yadav.a8ab18c4.docx";